// extracted by mini-css-extract-plugin
module.exports = {"container":"Events_ketogo_container__olKtk","item":"Events_ketogo_item__22DKV","workoutContainer":"Events_ketogo_workoutContainer__1QdD7"};